import React from 'react'
import { useGetCustomerByID } from '../../../../../api/dealership/customers/useGetCustomerByID'
import { useNavigate, useParams } from 'react-router'
import { Button, Pill, TabMenu } from '@demandlocal/components'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import Details from './Details'
import Audiences from './Audiences'
import Events from './Events'

function CustomerTemplate(): JSX.Element {
  const { customer_id } = useParams()
  const { data: customer } = useGetCustomerByID(customer_id)
  const navigate = useNavigate()
  const handleClose = (): void => {
    navigate('..')
  }
  return (
    <div className={'flex flex-1 flex-col'}>
      <div className="flex items-center justify-between px-6 py-4 ">
        <div className="flex items-center gap-3">
          <div className="rounded-full bg-primary-persian-blue/10 p-2.5 h-10 w-10 flex items-center justify-center font-semibold text-sm text-primary-persian-blue">
            <span>{customer?.first_name?.charAt(0)?.toUpperCase()}</span>
            <span>{customer?.last_name?.charAt(0)?.toUpperCase()}</span>
          </div>
          <div className="flex flex-col">
            <div className="flex items-center gap-2">
              <span className="font-semibold text-gray-900">
                {customer?.first_name} {customer?.last_name}
              </span>
              {customer?.is_business === 1 && <Pill type="info-purple">Business</Pill>}
            </div>
            {customer?.business_name && (
              <span className="text-sm text-gray-500">{customer.business_name}</span>
            )}
          </div>
        </div>
        <div className="flex items-center gap-4">
          <div className="flex flex-col items-end">
            <span className="text-xs text-gray-400">Customer ID</span>
            <span className="text-xs font-mono text-gray-600">{customer?.id}</span>
          </div>
        </div>
      </div>
      <div className={'p-4'}>
        <TabMenu
          options={[
            {
              name: 'Summary',
              to: 'summary',
            },
            {
              name: 'Audiences',
              to: 'audiences',
            },
            {
              name: 'Events',
              to: 'events',
            },
          ]}
        />
      </div>
      <div className={'flex flex-1 h-auto overflow-hidden'}>
        <Outlet />
      </div>
      <div className={'p-4 flex justify-between items-center'}>
        <Button animate={false} variant={'secondary'} onClick={handleClose}>
          Close
        </Button>
      </div>
    </div>
  )
}

export default function Customer(): JSX.Element {
  return (
    <Routes>
      <Route element={<CustomerTemplate />}>
        <Route path={'summary'} element={<Details />} />
        <Route path={'events'} element={<Events />} />
        <Route path={'audiences'} element={<Audiences />} />
        <Route path={'*'} element={<Navigate replace to={'summary'} />} />
      </Route>
    </Routes>
  )
}
